import React from 'react';
import { EducationEntry } from '../../types';
import { useApp } from '../../context/AppContext';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionTitle from '../ui/SectionTitle';
import { etiqueta } from '../../data/etiquetas';
import './Education.css';

interface Props {
  education: EducationEntry[];
}

const Education: React.FC<Props> = ({ education }) => {
  const { t, lang } = useApp();
  const ref = useScrollReveal();

  return (
    <section className="education" id="educacion">
      <div
        className="education__inner reveal-section"
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        <SectionTitle
          eyebrow={lang === 'es' ? 'Formación académica' : 'Academic background'}
          title={lang === 'es' ? 'Educación' : 'Education'}
          number="04"
        />

        <div className="education__grid">
          {education.map((entry, i) => (
            <div key={i} className="education-card">
              <div className="education-card__year">{entry.year}</div>
              <h3 className="education-card__degree">{t(entry.degree)}</h3>
              <p className="education-card__institution">{entry.institution}</p>
              <div className="education-card__tags">
                {entry.tags.map(tag => (
                  <span key={tag} className="education-card__tag">{etiqueta(tag, lang)}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
